import { Box, Typography } from "@mui/material";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";
import useCopyAccessLink from "@/modules/lead-page/hooks/lead-info/lead-actions/copy-access-link.hook";

export const CopyAccessLink = () => {
  const { onCopyAccessLink, isLoading } = useCopyAccessLink();

  return (
    <Box
      sx={{
        display: "flex",
        gap: nawyTheme.nawy.spacing.xs,
        padding: nawyTheme.nawy.spacing.xs,
        alignItems: "center",
        width: "100%",
        height: "100%",
        cursor: isLoading ? "wait" : "pointer",
        opacity: isLoading ? 0.6 : 1,
        ":hover": {
          backgroundColor: nawyTheme.nawy.colors.semantic.layer.secondary,
        },
      }}
      onClick={() => onCopyAccessLink()}
    >
      <Typography
        sx={{
          color: nawyTheme.nawy.colors.semantic.text.primary,
          ...nawyTheme.nawy.typography.english.variants.body.md.regular,
        }}
      >
        Copy Access Link
      </Typography>
    </Box>
  );
};

